const calculateFeedEP = (graph, unit) => {
    let totalFlow = parseFloat(graph.getConnectedLinks(unit)[0].attributes['complete_Stream_Properties']['totalFlow'])
    let feedCost = parseFloat(unit.attributes['equipment_Economics']['Cost']['Value'])
    //check if a component or Total Feed has been selected for unit
    let selectedComponent = unit.attributes['equipment_Properties']['selectedFeedDropDownValue']
    let streamEP = totalFlow * feedCost
    if (((selectedComponent) && (selectedComponent != 'Total Feed'))) {
        console.log("stream EP calc for Total Feed is Running " + streamEP + " " + totalFlow + " " + feedCost)
        let outputStream = graph.getConnectedLinks(unit)
        totalFlow = outputStream[0].attributes['complete_Stream_Properties']['massFlow'][selectedComponent]
        console.log(outputStream + " is output stream")
        streamEP = totalFlow * feedCost
        console.log("stream EP calc for Total Feed is Running " + streamEP + " " + totalFlow + " " + feedCost)
    }
    return streamEP
}

export default calculateFeedEP